import { serializeCsvContent } from "../../characterization-2/core/utils/buildCharacterizationCsvFiles";
import { downloadFile } from "../../../shared/utils/utils";
import { formatRgb } from "./materialsCatalog";

const fileDateSuffix = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}_${month}_${day}`;
};

export function buildLegendCsvRows(materials, t) {
  const header = [
    t("materialsCatalog.csvName"),
    t("materialsCatalog.csvHex"),
    t("materialsCatalog.csvRgb"),
  ];

  const rows = materials.map((material) => [
    material.name,
    material.displayColor || "",
    formatRgb(material.displayColor) || "",
  ]);

  return [header, ...rows];
}

/** Même contenu que le CSV : nom affiché + couleurs HTML et RGB. */
export function buildLegendPalette(materials) {
  return materials.map((material) => ({
    name: material.name,
    hex: material.displayColor || "",
    rgb: formatRgb(material.displayColor) || "",
  }));
}

export async function downloadLegendCsv(materials, t) {
  const blob = new Blob(
    [serializeCsvContent(buildLegendCsvRows(materials, t))],
    {
      type: "text/csv;charset=utf-8;",
    },
  );
  await downloadFile(blob, `palette_couleurs_matieres_${fileDateSuffix()}.csv`);
}

export async function downloadLegendJson(materials) {
  const blob = new Blob(
    [JSON.stringify(buildLegendPalette(materials), null, 2)],
    {
      type: "application/json;charset=utf-8;",
    },
  );
  await downloadFile(
    blob,
    `palette_couleurs_matieres_${fileDateSuffix()}.json`,
  );
}
